/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_image } from "../models/Body_upload_image";
import type { ImageUploadResponse } from "../models/ImageUploadResponse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class ImagesService {
  /**
   * Upload Image
   * Upload an org logo for the booking pages (admins), a logo for template
   * emails (admins; the brand kit's own) or a tutor photo (admins, or the
   * tutor themself). It replaces the current one, which is deleted. An email
   * image (admins) is for a message template's own HTML: it is kept.
   * @returns ImageUploadResponse Successful Response
   * @throws ApiError
   */
  public static uploadImage({
    formData,
  }: {
    formData: Body_upload_image;
  }): CancelablePromise<ImageUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/images",
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Get Image
   * An uploaded image, for public pages and the app. No login: the id can't
   * be guessed and the images are shown publicly anyway.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static getImage({
    imageId,
  }: {
    imageId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/images/{image_id}",
      path: {
        image_id: imageId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
}
